export default "__VITE_ASSET__9551a733__"